var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-provider',{attrs:{"rules":_vm.normalizedRules,"vid":_vm.vid,"id":_vm.vid,"mode":_vm.aggressive ? 'aggressive' : 'eager',"tag":"div"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var failed = ref.failed;
var failedRules = ref.failedRules;
return [_vm._t("default",null,{"failed":failed,"error":_vm.errorCode(failedRules)})]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }